import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import calendar from 'dayjs/plugin/calendar';

dayjs.extend(relativeTime);
dayjs.extend(calendar);

const CALENDAR_SETTINGS = [
  null,
  {
    sameDay: '[Today at] h:mm a', // The same day ( Today at 2:30 am )
    lastDay: '[Yesterday at] h:mm a', // The day before ( Yesterday at 2:30 am )
    lastWeek: 'MM/DD/YYYY [at] h:mm a', // Last week ( 10/17/2011 at 2:30 am )
    sameElse: 'MM/DD/YYYY [at] h:mm a' // Everything else ( 10/17/2011 at 2:30 am )
  }
];

export { CALENDAR_SETTINGS };

export default dayjs;
